import { render, staticRenderFns } from "./TravelServiceOrderItemHotelChip.vue?vue&type=template&id=eb6f5e84&scoped=true&"
import script from "./TravelServiceOrderItemHotelChip.vue?vue&type=script&lang=js&"
export * from "./TravelServiceOrderItemHotelChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb6f5e84",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VIcon,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb6f5e84')) {
      api.createRecord('eb6f5e84', component.options)
    } else {
      api.reload('eb6f5e84', component.options)
    }
    module.hot.accept("./TravelServiceOrderItemHotelChip.vue?vue&type=template&id=eb6f5e84&scoped=true&", function () {
      api.rerender('eb6f5e84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TravelService/Chips/TravelServiceOrderItemHotelChip.vue"
export default component.exports